import React from 'react';
import {Trans} from 'react-i18next';
import Section from '../../layout/Section';

export default function GetSkinResultCustomizedSetting() {
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.customized.ui.template">
          Template Info
        </Trans>
      }
    >
      <div>
        <Trans i18nKey="p.s.uiconfiguration.getskinresultpage.no.setting.desc">
          Skin Result Page and Get Skin Result Page must use the same template.
          Separate configuration is not supported.
        </Trans>
      </div>
    </Section>
  );
}
